import React from "react";
import "./HeaderSection.css";

const HeaderSection = ({ title, description }) => {
  return (
    <section className="header-modern">
      <div className="header-overlay"></div>

      <div className="header-content text-center">
        <h1 className="header-title">{title}</h1>
        <p className="header-description">{description}</p>
        <div className="header-accent"></div>
      </div>

      {/* Bottom Wave */}
      <div className="wave-container">
        <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path
            fill="#f8f9fa"
            d="M0,256L80,234.7C160,213,320,171,480,160C640,149,800,171,960,186.7C1120,203,1280,213,1360,218.7L1440,224V320H0Z"
          />
        </svg>
      </div>
    </section>
  );
};

export default HeaderSection;
